jQuery(document).ready(function($) {
    'use strict';

    const BOOKMARK_STATES = {
        ADDED: {
            iconRemove: 'icon-plus',
            iconAdd: 'icon-checkmark',
            text: 'Ligger i offertförfrågan',
        },
        NOT_ADDED: {
            iconRemove: 'icon-checkmark',
            iconAdd: 'icon-plus',
            text: 'Lägg i offertförfrågan',
        },
    };

    function track(data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }

    function updateBookmarkAppearance($button, isAdded) {
        const state = isAdded
            ? BOOKMARK_STATES.ADDED
            : BOOKMARK_STATES.NOT_ADDED;
        const $icon = $button.find('i');
        const $text = $button.find('span');

        $icon.removeClass(state.iconRemove).addClass(state.iconAdd);
        $text.text(state.text);
    }

    function getParsedBookmarks() {
        const bookmarks = getCookie('svm_bookmarks');
        if (!bookmarks || bookmarks.trim() === '') {
            return [];
        }
        return bookmarks
            .split(',')
            .map(Number)
            .filter(n => !isNaN(n));
    }

    function updateCookie(bookmarks) {
        const today = new Date();
        const expiry = new Date(
            today.getFullYear() + 1,
            today.getMonth(),
            today.getDate(),
        );
        document.cookie =
            `svm_bookmarks=${bookmarks.join(',')};expires=${expiry.toUTCString()};path=/`;
    }

    function refreshBookmarks() {
        const count = getParsedBookmarks().length;
        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            xhrFields: {withCredentials: true},
            data: {
                action: 'render_bookmarks',
                bookmarks: getCookie('svm_bookmarks'),
            },
            success: function(data) {
                $('.bookmarks').html(data);

                // The server drops ids that aren't hotels from the cookie
                if (getParsedBookmarks().length !== count) {
                    updateBookmarkCount();
                }
            },
        });
    }

    window.refreshBookmarks = refreshBookmarks; // need it global

    function refreshFormBookmarks() {
        $('.form-bookmarks').addClass('loading').css('min-height', '112px');
        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            xhrFields: {withCredentials: true},
            data: {
                action: 'render_form_bookmarks',
                bookmarks: getCookie('svm_bookmarks'),
            },
            success: function(data) {
                $('.form-bookmarks')
                    .html(data)
                    .removeClass('loading')
                    .css('min-height', '0');
            },
        });
    }

    function updateBookmarkCount() {
        const count = getParsedBookmarks().length;
        const $badge = $('.bookmark-count');
        const $bookmarks_footer = $('.bookmarks-flyout .flyout__footer');

        if (count === 0) {
            $badge.hide();
            $bookmarks_footer.hide();
        } else {
            $badge.text(count).css('display', 'flex');
            $bookmarks_footer.show();
            $badge.addClass('animate-pulsebadge');
            setTimeout(() => {
                $badge.removeClass('animate-pulsebadge');
            }, 600);
        }
    }

    window.updateBookmarkCount = updateBookmarkCount; // need it global

    updateBookmarkCount();

    $(document).on('click', '.get-bookmarks', function(e) {
        e.preventDefault();
        refreshBookmarks();
    });

    $(document).on('click', '.get-form-bookmarks', function(e) {
        e.preventDefault();

        // Add cookie for Offert request button bookmark
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1); // ett år framåt

        document.cookie =
            'offer_request_bookmark_clicked=true; path=/; expires=' +
            date.toUTCString();

        // Set hidden input too
        $('#offer_request_bookmark_clicked').val('true');

        checkOfferRequestCookieAndUpdateUI();
        refreshFormBookmarks();

        //console.log("Request offer button was clicked in menu.");
    });

    $('.bookmark').each(function() {
        let bookmarkArray = getParsedBookmarks();
        const $this = $(this);
        const id = parseInt($this.data('id'));

        updateBookmarkAppearance($this, bookmarkArray.includes(id));

        $this.on('click', function(e) {
            e.preventDefault();

            const id = parseInt($(this).data('id'));
            const name = $(this).data('name');
            bookmarkArray = getParsedBookmarks();

            const isAdding = $(this).find('i').hasClass('icon-plus');
            if (isAdding && bookmarkArray.length >= 5) {
                let $warning = $(this).siblings('.bookmark-warning');

                if ($warning.length === 0) {
                    $warning =
                        $('<div class="bookmark-warning text-red-600 text-sm mb-2"></div>');
                    $(this).before($warning);
                }

                $warning
                    .text(
                        'Du kan lägga max 5 konferensanläggningar i offertförfrågan.')
                    .stop(true, true)
                    .fadeIn()
                    .delay(2000)
                    .fadeOut();

                return;
            }

            $('.bookmarks').html('');

            if (isAdding) {
                bookmarkArray.push(id);

                if (name) {
                    track({
                        event: 'bookmark_add',
                        hotel: name,
                    });
                }
            } else {
                bookmarkArray = bookmarkArray.filter(b => b !== id);

                if (name) {
                    track({
                        event: 'bookmark_remove',
                        hotel: name,
                    });
                }
            }

            updateBookmarkAppearance($this, isAdding);
            updateCookie(bookmarkArray);
            updateBookmarkCount();
            refreshBookmarks();
        });
    });

    $(document).on('click', '.bookmark-delete', function(e) {
        e.preventDefault();
        let bookmarkArray = getParsedBookmarks();
        const $this = $(this);
        const id = parseInt($this.data('id'));
        const name = $this.data('name');
        const $button = $('.bookmark[data-id="' + id + '"]');

        updateBookmarkAppearance($button, false);
        bookmarkArray = bookmarkArray.filter(b => b !== id);
        updateCookie(bookmarkArray);
        updateBookmarkCount();
        $this.parent().remove();

        if (name) {
            track({
                event: 'bookmark_remove',
                hotel: name,
            });
        }

        if (bookmarkArray.length === 0) {
            refreshBookmarks();
        }
    });

    function checkOfferRequestCookieAndUpdateUI() {

        //console.log("Check offer request cookie ...");

        const cookieExists = document.cookie
            .split(';')
            .map(c => c.trim())
            .some(c => c.startsWith('offer_request_bookmark_clicked=') &&
                c.includes('=true'));

        const selectedAreasInput = document.getElementById('selected-areas-list');
        if (selectedAreasInput) {
            selectedAreasInput.value = '';
        }

        if (cookieExists) {
            const label = document.querySelector('.area-wrapper');
            if (label) {
                label.style.display = 'none';
            }

            const grid = document.getElementById('bookmark-grid');
            if (grid) {
                grid.classList.remove('md:grid-cols-2');
                grid.classList.add('md:grid-cols-1');
            }

            // Advanced form
            const labelAdvanced = document.getElementById(
                'advanced-area-wrapper');
            if (labelAdvanced) {
                labelAdvanced.style.display = 'none';
            }
        }
    }

    window.checkOfferRequestCookieAndUpdateUI =
        checkOfferRequestCookieAndUpdateUI; // need it global

});
